export const OEBlue = '#003469';
export const OELighterBlue = "#E8ECF4";
export const SeparatorColor = "#BECCE6"


export const mainHeaderStyle: React.CSSProperties = {
    fontSize: "calc(14px + 1vmin)",
    fontWeight: "bold",
    color: OEBlue
};

export const gridContainerStyle: React.CSSProperties = {
    background: OELighterBlue,
    width: "100%",
    height: "100%",
    padding: "2vh 2vw",
    textAlign: "left",
    borderRadius: "5px"
};

